import { SocialPlatformId } from '@app/modules/social-export/domain/platforms';
import {
  CreateFragmentDto,
  FragmentChunkDto,
  GetFragmentDto,
  PartialRecord,
  Segment,
} from '@mi-front/core';

export type Fragment = GetFragmentDto;

export type FragmentFromIndex = GetFragmentDto;

type BaseCreateFragmentData = CreateFragmentDto & {
  doExternalExport?: boolean;
  platformUpload?: PartialRecord<
    SocialPlatformId,
    {
      enabled: boolean;
      config?: unknown;
    }
  >;
};

export type CreateDefaultFragmentData = BaseCreateFragmentData & Pick<Fragment, 'from' | 'to'>;

export type CreateJointFragmentData = BaseCreateFragmentData & Pick<Fragment, 'chunks'>;

export type FragmentChunk = FragmentChunkDto;

export type CompleteChunk = FragmentChunkDto;

export type DisplayableJointFragment<T> = {
  chunks: DisplayableChunk[];
};
export type DisplayableChunk = FragmentChunk & {
  color: string;
  segments: readonly Segment[];
};

export function isSavedFragment(f: Fragment | DisplayableJointFragment<any>): f is Fragment {
  return !!(f as Fragment).id;
}
